<template>
  <div
    class="control"
    :class="{off: !isTorchOn}"
    title="Turn on flash"
    v-tooltip.left="isTorchOn? 'Turn off flash': 'Turn on flash'"
    @click="toggleTorch"
  >
    <img v-if="!isTorchOn" src="../../assets/icon_flash_off.svg" style="height: 30px;">
    <img v-if="isTorchOn" src="../../assets/icon_flash_on.svg" style="height: 30px;">
  </div>
</template>

<script>
  export default {
    name: 'TorchControl',
    props: {
      localDataTrack: {
        type: Object
      },
      remoteDataTrack: {
        type: Object
      }
    },

    data: () => ({
      isTorchOn: false,
      lastTorchSent: null
    }),

    methods: {
      toggleTorch() {
        this.isTorchOn = !this.isTorchOn;
        this.lastTorchSent = (this.isTorchOn? 1: 0).toString();

        this.localDataTrack.send(`T,${this.lastTorchSent}`)
      },
      subscribeToRemoteTrack() {
        if(this.remoteDataTrack) {
          this.remoteDataTrack.on('message', (data) => {
            if(/^T,[01]$/.test(data)) {
              let command = data.split(',')[1];
              this.isTorchOn = command === '1'
            } else if(/^T,C,[01]$/.test(data)) {
              let command = data.split(',')[2];
              if(command !== this.lastTorchSent) {
                this.isTorchOn = false;
              }
            }

          })

        }
      }
    },

    created() {
      this.subscribeToRemoteTrack()
    },

    watch: {
      remoteDataTrack() {
        this.subscribeToRemoteTrack()
      }
    }
  }
</script>

<style scoped>

</style>
